"use client";

import { useHubMotion } from "./hooks";

export interface HubPoint {
  x: number;
  y: number;
}

interface HubCanvasProps {
  ariaLabel: string;
  centreLabel: string;
  centre: HubPoint;
  // Where each connector line leaves its node.
  lineStarts: HubPoint[];
}

// The animated layer of the integrations hub: the flowing connector lines and
// the pulsing centre circle. It fills its parent; the node pills are HTML
// laid over it (see IntegrationsHub) so their labels can never be clipped.
const HubCanvas = ({
  ariaLabel,
  centreLabel,
  centre,
  lineStarts,
}: HubCanvasProps) => {
  const { linesRef, ringRef } = useHubMotion();
  return (
    <svg
      viewBox="0 0 760 430"
      role="img"
      aria-label={ariaLabel}
      className="absolute inset-0 size-full font-sans"
    >
      <g
        ref={linesRef}
        fill="none"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeDasharray="3 10"
        className="stroke-primary"
      >
        {lineStarts.map((start) => (
          <path
            key={`${start.x}-${start.y}`}
            d={`M${start.x} ${start.y} L${centre.x} ${centre.y}`}
          />
        ))}
      </g>
      <circle
        ref={ringRef}
        cx={centre.x}
        cy={centre.y}
        r={54}
        className="origin-center fill-tone-blush [transform-box:fill-box]"
      />
      <circle cx={centre.x} cy={centre.y} r={42} className="fill-primary" />
      <text
        x={centre.x}
        y={centre.y + 8}
        fontSize={23}
        fontWeight={800}
        textAnchor="middle"
        className="fill-white"
      >
        {centreLabel}
      </text>
    </svg>
  );
};

export default HubCanvas;
